import React from 'react';
import { Loadable } from 'shared/hocs/loadable';
import { Loader } from 'shared/ui/loader';


export const WinterShuffleLoadable = Loadable({
    loader: (): any => import('./WinterShuffle').then((res) => res.WinterShuffle),
    loading: <Loader/>,
});
